// src/lib/sessionByToken.js
//
// Token-checked reads of a single saved result session. The result pages used
// to query triage_sessions / calculator_sessions directly, which required
// open (USING true) SELECT policies. These wrappers call SECURITY DEFINER RPCs
// (supabase/migrations/009_session_token_read.sql) that return one session by
// public_token with only the fields the page needs, never the email or the
// owner's user id. Ownership comes back as { is_owner, is_claimed } flags.
//
// Returns { data, error }. data is null when no session matches (or the
// calculator session is soft-deleted); callers treat that as "not found".
// A non-uuid token surfaces as an error (Postgres 22P02), also "not found".

import { supabase } from './supabase'

export function fetchTriageSessionByToken(token) {
  return supabase.rpc('get_triage_session_by_token', { p_token: token })
}

export function fetchCalculatorSessionByToken(token) {
  return supabase.rpc('get_calculator_session_by_token', { p_token: token })
}
